import React, { useState } from 'react';
import { Accordion } from '@ver-uds/uswds-react';
import { ResourceCategory } from '../../../models/Resources';
import useResourceService from '../../../services/ResourceService';
import ResourceLink from './ResourceLink';
import './CategoryInfo.scss';
import { useAccount } from '../../../context/Account/AccountContext';

export type Props = {
  category: ResourceCategory;
};

const CategoryInfo: React.FC<Props> = ({ category }: Props) => {
  const [subcategories, setSubcategories] = useState<ResourceCategory[]>([]);
  const [error, setError] = useState<boolean>(false);
  const resourceService = useResourceService();
  const account = useAccount();

  function updateSubcategories(subcategory: ResourceCategory): void {
    if (subcategory.subCategories && subcategories.length === 0) {
      resourceService
        .getSubcategories(subcategory.id, account.type)
        .then((data) => data.json())
        .then((data) => {
          setSubcategories(
            (category.subCategoriesObject as ResourceCategory[]).map((s) =>
              s.id === subcategory.id ? { ...s, subCategoriesObject: data } : s,
            ),
          );
        })
        .catch(() => {
          setError(true);
        });
    }
  }

  function renderSubcategory(subcategory: ResourceCategory, index: number): JSX.Element {
    const renderedSubcategory = subcategories && subcategories[index] ? subcategories[index] : subcategory;
    return (
      <div className="links subcategory-links">
        <CategoryInfo category={renderedSubcategory} />
      </div>
    );
  }

  if (error) {
    throw new Error('could not fetch subcategories');
  }

  return (
    <>
      {category.description}
      {category.documents.length > 0 && (
        <div className={category.description ? 'links padded-links' : 'links'}>
          {category.documents?.map((resource) => (
            <ResourceLink key={resource.link} resource={resource} />
          ))}
        </div>
      )}
      {category.subCategoriesObject && (
        <Accordion multiple>
          {category.subCategoriesObject.map((subcategory, index) => (
            <div key={subcategory.id} className="resource-subcategory">
              <Accordion.Heading controls={`a${index}`}>{subcategory.title}</Accordion.Heading>
              <Accordion.Content id={`a${index}`} onOpen={(): void => updateSubcategories(subcategory)}>
                {renderSubcategory(subcategory, index)}
              </Accordion.Content>
            </div>
          ))}
        </Accordion>
      )}
    </>
  );
};
export default CategoryInfo;
